import React, { Component } from 'react';
import Immutable from 'immutable';
import Hidden from '@material-ui/core/Hidden';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';

import {
  isLoggedIn,
  getCurrentUserRole,
} from 'ducks/authentication';

import IconSetMenu from 'components/Icon/IconSetMenu';


class HeaderMenu extends Component {
  contructor(props) {
    this.super(props);
    // this._onclick = this._onclick.bind(this);
  }

  _onClick(e, href) {
    const id = href.replace('/#', '')
    // console.log(document.getElementById('header').offsetHeight)
    // console.log('ID IS', id)
    if (['mission'].indexOf(id) < 0) {
      const top = document.getElementById(id) ? document.getElementById(id).offsetTop+10-document.getElementById('header').offsetHeight : false
      window.scroll({
        top,
        behavior: 'smooth'
      })
    }
    if (this.props.onClick) this.props.onClick();
  }
  render() {
    const { loggedIn, mode, userRole } = this.props;
    const menuSize = this.props.menuSize;
    const menu = [
      { icon: 'home', title: 'Home', url: '/'},
      { icon: 'recruitment', title: 'Le recrutement à votre image', url: '/#recrutement'},
      { icon: 'recruit', title: 'Côté Candidat', url: '/#candidat'},
      { icon: 'company', title: 'Côté Entreprise', url: '/#entreprise'},
      { icon: 'sample', title: 'Un exemple', url: '/#example'},
      { icon: 'units', title: 'Nos Pôles d’Expertise', url: '/#poles'},
      { icon: 'team', title: 'L’Equipe', url: '/#equipe'},
      { icon: 'ethic', title: 'L’Ethique', url: '/#ethique'},
      { icon: 'about', title: 'Lobster, c’est...', url: '/#apropos'},
      { icon: 'contact', title: 'Contacts', url: '/#contact'},
    ];
    const $$menu = Immutable.fromJS(menu);

    // const subMenu = [];
    // if (userRole === 'entreprise')
    //   subMenu.push({'label': 'Missions', 'url': '/mission'});
    // else if (userRole === 'candidat')
    //   subMenu.push({'label': 'Mon Profil', 'url': '/profile'});
    // subMenu.push({'label': 'Déconnexion', 'url': '/logout'});
    // const $$subMenu = Immutable.fromJS(subMenu);
    const inlineButtonStyle = {backgroundColor: '#e24b4b', color: '#fff', marginRight: 5};
    const inlineBulletStyle = {width: 28, textAlign: 'center', marginRight: 0};
    return (
      <div className={'HeaderMenu'+(mode === 'vertical' ? ' vertical' : '')}>
        {$$menu.map((menu, i) =>
          <IconSetMenu key={'tm_'+i} icon={menu.get('icon')} title={menu.get('title')} url={menu.get('url')} className={'HeaderMenuIcon'} size={menuSize} onClick={this._onClick.bind(this)} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} />
        ).toArray()}
        <Hidden mdDown>
        <If condition={loggedIn}>
          <IconSetMenu icon={'logout'} title={'Déconnexion'} url={'/logout'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} buttonStyle={{backgroundColor: '#e24b4b', color: '#fff'}} />
        </If>
        </Hidden>
        <Hidden lgUp>
          <If condition={(!loggedIn || loggedIn === undefined) && menuSize !== 28}>
            <IconSetMenu icon={'login'} title={'Connexion'} url={'/login'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} buttonStyle={{backgroundColor: '#e24b4b', color: '#fff'}} onClick={this._onClick.bind(this)}  />
          </If>
          <If condition={loggedIn && menuSize !== 28}>
            <If condition={userRole !== undefined && userRole === 'entreprise'}>
              <IconSetMenu icon={'missions'} title={'Mes  Missions'} url={'/mission'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} buttonStyle={{backgroundColor: '#e24b4b', color: '#fff'}} onClick={this._onClick.bind(this)}  />
            </If>
            <If condition={userRole !== undefined && userRole === 'candidat'}>
              <IconSetMenu icon={'profile'} title={'Mon Profil'} url={'/profil'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} buttonStyle={{backgroundColor: '#e24b4b', color: '#fff'}} onClick={this._onClick.bind(this)}  />
            </If>
              <IconSetMenu icon={'logout'} title={'Déconnexion'} url={'/logout'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} buttonStyle={{backgroundColor: '#e24b4b', color: '#fff'}} onClick={this._onClick.bind(this)}  />
          </If>
          <If condition={(!loggedIn || loggedIn === undefined) && menuSize === 28}>
            <IconSetMenu icon={'login'} title={'Connexion'} url={'/login'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} buttonStyle={inlineButtonStyle} style={inlineBulletStyle} onClick={this._onClick.bind(this)}  />
          </If>
          <If condition={loggedIn && menuSize === 28}>
            <If condition={userRole === 'entreprise'}><IconSetMenu icon={'login'} title={'Missions'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} onClick={this._onClick.bind(this)} url={'/mission'} buttonStyle={inlineButtonStyle} style={inlineBulletStyle} /></If>
            <If condition={userRole === 'candidat'}><IconSetMenu icon={'login'} title={'Profil'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} onClick={this._onClick.bind(this)} url={'/profil'} buttonStyle={inlineButtonStyle} style={inlineBulletStyle} /></If>
            <IconSetMenu icon={'logout'} title={'Déconnexion'} className={'HeaderMenuIcon'} size={menuSize} showTooltip={mode !== 'vertical'} showLabel={mode === 'vertical'} onClick={this._onClick.bind(this)} url={'/logout'} buttonStyle={inlineButtonStyle} style={inlineBulletStyle} />
          </If>
        </Hidden>

      </div>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    loggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}

// export default HeaderMenu;
export default connect(mapStateToProps)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderMenu.jsx